import Footer from "../components/footer";
import Header from "../components/header"
import SideNav from "../components/sidenav"
import PageHeader from "../components/pageHeader";
import React, { useEffect, useState } from "react";
import DataTable from "react-data-table-component";
import { Link , useNavigate} from "react-router-dom";
import debounce from 'lodash.debounce';

const Subject = () =>{

    const navigate = useNavigate();
    const [dataSubject, setDataSubject] = useState([]);
    const [filteredData, setFilteredData] = useState([]);
    const [searchQuery, setSearchQuery] = useState('');
    
    // Function to Fetch data from API for dropdown
    const fetchData = async (url, setData) => {

        try {
            const response = await fetch(url);
            const data = await response.json();
            setData(data);
        } catch (error) {
            console.error('Error fetching data:', error);
        }

    };

    useEffect(() => {
        fetchData('https://igapi.heuristticminds.com/api/SubjectStyleList/Get-GetSubjectDetailsAll', setDataSubject);

    }, [dataSubject]);

    // Filter Data based on searchQuery
        useEffect(() => {
            const lowercasedFilter = searchQuery.toLowerCase();
            const filtered = dataSubject.filter(item =>
                item.subject.toLowerCase().includes(lowercasedFilter) ||
                item.id.toString().toLowerCase().includes(lowercasedFilter)
            );
            setFilteredData(filtered);
        }, [searchQuery, dataSubject]);
    
    
    // Debounced search handler to avoid excessive re-renders
        const handleSearchChange = debounce((e) => {
            setSearchQuery(e.target.value);
        }, 300);

    const columns = [
        {
            name: "Subject",
            selector: row => row.subject,
            sortable: true,
            width: "300px"
        },
        /* {
            name: "Description",
            selector: row => row.description,
            cell: (row) => (
                <div style={{ whiteSpace: "pre-line", width: "1350px" }} dangerouslySetInnerHTML={{ __html: row.description }} />
            ),
            allowOverflow: true,
            maxWidth:"600px",
        }, */
        {
            name: "Action",
            cell: (row) => (
                <div>
                    <Link to={``} onClick={() => onStatusClick(row.id)}>
                        <img
                            src={row.status === 1 ? "/images/ImgActive.gif" : "/images/ImgInActive.gif"}
                            alt="Change Status"
                            title="Change Status"
                            style={{ width: "50px", height: "25px" }}
                        />
                    </Link>

                    {' '} {' '}{' '} {' '}{' '} {' '}{' '} {' '}
                    <Link to={``} onClick={(event) => onEditClick(event, row.id)}>
                        <img
                            src="/images/ImgEdit.ico" // Set the correct image source
                            alt="Edit"
                            title="Edit"
                            style={{ width: "30px", height: "30px" }}
                        />
                    </Link>
                </div>
            ),
            maxWidth:"200px",

        },
    ];

    const onStatusClick = async (id) =>{
        const confirmed = window.confirm("Are you sure you want to change Subject status?");
        if (!confirmed) {
            return; // If not confirmed, return early without deleting
        }
        try {
            
            const response = await fetch('https://igapi.heuristticminds.com/api/SubjectStyleList/Update-ChangeSubjectStatus?id=' + id, {
                method: 'PUT',
                headers: {
                    'Content-Type': 'application/json',
                },
            });
            if (response.ok) {
                
            }
        }
        catch {
        }
    }

    const onEditClick = async (event, id) => {

        event.preventDefault(); // Prevents the default behavior of the link
        navigate(`/addSubject/${id}`);
    }

    return (
        <>
            <Header />
            <div id="layoutSidenav">
                <SideNav />
                <div id="layoutSidenav_content">

                    <PageHeader name='Subject' icon='bi bi-activity' />
                    <div className="container-xl px-4">
                        <div className="row">
                            <div className="col-lg-12 mb-4">
                                <div className="card mb-4">
                                    <div className="card-header">Subject Details</div>
                                        <div className="card-body">
                                            <div className="row">
                                                <div className="col-sm-12">
                                                    <a href="/addSubject" className="btn btn-primary"><i className="bi bi-plus-circle-fill"></i> Add Subject</a>
                                                </div>
                                            </div>
                                    <div className="pb-2">   
                                                <div className="col-lg-9">

                                                </div>
                                                <div className="col-lg-3">
                                                    <input type="text" name="search" onChange={handleSearchChange} className="form-control" placeholder="Text Search" />
                                                </div>                                 
                                        <div className="ps-2 pe-2">
                                            <DataTable 
                                                columns={columns}
                                                data={filteredData}
                                                pagination
                                            /> 
                                        </div>   
                                    </div>
                                    </div>

                                </div>
                                    
                                    
                                    
                                
                            </div>

                        </div>
                    </div>
                    
                    <Footer />
                </div>
                
            </div>
        </>
    )
};
export default Subject;